import React, { useState, useEffect, Fragment } from "react";
import { Card, Modal } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";
import Select from "react-select";
import { toast } from "react-toastify";
import { academylist, wardenlist } from "../../../services/admin";
import { hostelcreate, hosteldelete, hosteldetail, hostellist, hostelupdate, hostelvalidate } from "../../../services/master";
export const HostelMaster = () => {
    const [filterProduct, setFilterProduct] = useState([]);
    const [Catid, setID] = useState(0);
    const [name, setName] = useState("");
    const [htype, setHType] = useState("");
    const [addr, setAddr] = useState("");
    const [tmem, setTMem] = useState("");
    const [desc, setDesc] = useState("");

    const [alist, setAList] = useState([]);
    const [acaid, setAcaID] = useState("");

    const [errorMessage, setErrorMessage] = useState("");
    useEffect(() => {
        funlist();
        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setAList(arr);
                }
            }
        });


    }, []);

    function funlist() {
        setFilterProduct([]);
        hostellist("").then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data);
            }
        });
    }
    const columnDefs = [
        {
            headerName: "Hostel",
            width: 280,
            field: "name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Type",
            width: 120,
            field: "type",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Academy",
            width: 200,
            field: "academy_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Warden",
            width: 200,
            field: "worker_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Status",
            width: 100,
            field: "active",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <label className="custom-switch mb-0">
                            <input
                                type="checkbox"
                                name="custom-switch-checkbox"
                                className="custom-switch-input"
                                checked={params.value === 1 ? true : false}
                                onChange={() => handleSwitch(params)}
                            />

                            <span className="custom-switch-indicator"></span>
                        </label>
                    </div>
                );
            },
        },
        {
            headerName: "Actions",
            width: 100,
            field: "id",
            resizable: true,
            filter: false,
            // headerClass: "ag-center-aligned-header",
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={() => viewshow(params.value)}
                            className="btn-sm btn-info"
                        >
                            <i className="fa fa-edit"></i>
                        </a>
                    </div>
                );
            },
        },
    ];

    const columnWDefs = [
        {
            headerName: "Hostel",
            width: 200,
            field: "name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Type",
            width: 150,
            field: "type",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Warden",
            width: 200,
            field: "worker_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Status",
            width: 100,
            field: "active",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <label className="custom-switch mb-0">
                            <input
                                type="checkbox"
                                name="custom-switch-checkbox"
                                className="custom-switch-input"
                                checked={params.value === 1 ? true : false}
                                onChange={() => handleSwitch(params)}
                            />

                            <span className="custom-switch-indicator"></span>
                        </label>
                    </div>
                );
            },
        },
        {
            headerName: "Actions",
            width: 150,
            field: "id",
            resizable: true,
            filter: false,
            // headerClass: "ag-center-aligned-header",
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={() => viewshow(params.value)}
                            className="btn-sm btn-info"
                        >
                            <i className="fa fa-edit"></i>
                        </a>
                    </div>
                );
            },
        },
    ];

    function handleSwitch(list) {
        if (list.value === 1) {
            Swal.fire({
                text: "Are you sure want to Inactive?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#ac0404",
                cancelButtonColor: "#6259ca",
                confirmButtonText: "Inactive",
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const temp = new FormData();
                    temp.append("id", list.data.id);
                    temp.append("status", 0);

                    hosteldelete(temp).then((response) => {
                        if (response.status === true) {
                            funlist();
                        }
                    });
                }
            });
        } else {
            Swal.fire({
                text: "Are you sure want to Active?",
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#008000",
                cancelButtonColor: "#6259ca",
                confirmButtonText: "Active",
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const temp = new FormData();
                    temp.append("id", list.data.id);
                    temp.append("status", 1);

                    hosteldelete(temp).then((response) => {
                        if (response.status === true) {
                            funlist();
                        }
                    });
                }
            });
        }
    }

    const [show, setShow] = useState(false);
    function handleshow() {
        setID(0);
        setName("");
        setHType("");
        setAddr("");
        setTMem("");
        setDesc("");
        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.details.length > 0) {
                        for (let i = 0; i < res.data.details.length; i++) {
                            if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                                arr.push({
                                    value: res.data.details[i].id,
                                    label:
                                        res.data.details[i].name + " - " + res.data.details[i].code,
                                });
                            }
                            if (arr.length > 0) {
                                setAcaID(arr[0]);
                            }
                        }

                    }
                }
            });
        }
        setErrorMessage("");
        setShow(true);
    }

    function handleclose() {
        setID(0);
        setAcaID("");
        setHType("");
        setName("");
        setAddr("");
        setTMem("");
        setDesc("");
        setErrorMessage("");
        setShow(false);
    }

    function viewshow(vid) {
        setID(vid);
        setName("");
        setHType("");
        setAddr("");
        setTMem("");
        setDesc("");
        setShow(true);

        setErrorMessage("");
        hosteldetail(vid).then((response) => {
            if (response.status === true) {
                setName(response.data.name);
                setHType(response.data.type);
                setAddr(response.data.address);
                setTMem(response.data.total);
                setDesc(response.data.description);
                academylist().then((res) => {
                    if (res.status === true) {
                        let arr = [];
                        if (res.data.details.length > 0) {
                            for (let i = 0; i < res.data.details.length; i++) {
                                if (res.data.details[i].id === response.data.academy_id) {
                                    arr.push({
                                        value: res.data.details[i].id,
                                        label:
                                            res.data.details[i].name + " - " + res.data.details[i].code,
                                    });
                                }
                            }
                            setAcaID(arr[0]);
                            listwar(arr[0]);
                        }
                    }
                });
                const temp = new FormData();
                temp.append("academy_id", response.data.academy_id);
                wardenlist(temp).then((res) => {
                    if (res.status === true) {
                        let arr = [];
                        if (res.data.details.length > 0) {
                            for (let i = 0; i < res.data.details.length; i++) {
                                if (res.data.details[i].id === response.data.warden) {
                                    arr.push({
                                        value: res.data.details[i].id,
                                        label:
                                            res.data.details[i].worker_name + " - " + res.data.details[i].employee_id + " (" + res.data.details[i].username + ")",
                                    });
                                }
                                setDriverid(arr[0]);

                            }
                        }
                    }
                });
            }
        });
    }



    function Submitage() {
        setErrorMessage("");
        let valid = "";
        if (localStorage.getItem("Role") === "1") {
            if (acaid === "") {
                setErrorMessage("Please Select Academy");
                valid = "Please Select Academy";
            }
        } else {
            valid = "";
        }
        if (valid === "") {
            if (name !== "") {
                if (htype !== "") {
                    const temp = new FormData();
                    temp.append("name", name);
                    temp.append("id", Catid);

                    if (localStorage.getItem("Role") === "1" && acaid !== "") {
                        temp.append("academy_id", acaid.value);
                    }
                    hostelvalidate(temp).then((response) => {
                        if (response.status === false) {
                            setErrorMessage(response.message);
                        } else {
                            const tempData = new FormData();
                            tempData.append("name", name);
                            tempData.append("type", htype);
                            tempData.append("address", addr);
                            tempData.append("total", tmem);
                            tempData.append("description", desc);
                            tempData.append("user_id", localStorage.getItem("UID"));
                            if (localStorage.getItem("Role") === "1" && acaid !== "") {
                                tempData.append("academy_id", acaid.value);
                            }
                            if (driverid !== '') {
                                tempData.append("warden", driverid.value);
                            } else {
                                tempData.append("warden", '');
                            }

                            if (Catid === 0) {
                                hostelcreate(tempData).then((response) => {
                                    if (response.status === true) {
                                        handleclose();
                                        funlist();
                                        toast.success(response.message);
                                    } else {
                                        setErrorMessage(response.data.message);
                                    }
                                });
                            } else {
                                tempData.append("id", Catid);
                                hostelupdate(tempData).then((response) => {
                                    if (response.status === true) {
                                        handleclose();
                                        funlist();
                                        toast.success(response.message);
                                    } else {
                                        setErrorMessage(response.data.message);
                                    }
                                });
                            }
                        }
                    });
                } else {
                    setErrorMessage("Please Select Type");
                }

            } else {
                setErrorMessage("Please Enter Hostel");
            }
        }

    }

    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);
            listwar(e);
        } else {
            setAcaID("");
            listwar('');

        }
    }
    const [dlist, setDriverlist] = useState([]);
    const [driverid, setDriverid] = useState("");

    function listwar(aid) {
        setDriverlist([]);
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
            temp.append("academy_id", aid.value);
        }
        wardenlist(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].worker_name + " - " + res.data.details[i].employee_id + " (" + res.data.details[i].username + ")",
                        });
                    }
                    setDriverlist(arr);
                }
            }
        });
    }

    function handleDriver(e) {
        if (e !== null) {
            setDriverid(e);
        } else {
            setDriverid("");
        }
    }
    return (
        <Fragment>
            <div className="page-header reported-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Hostel</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a>Hostel Management</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Hostel
                        </li>
                    </ol>
                </div>
            </div>
            <Row className="row-sm mx-0 mt-3">
                <Col xxl={12} lg={12} md={12}>
                    <Card className="custom-card overflow-hidden">
                        <Card.Body>
                            <div className="responsive">
                                <div className="res-right">
                                    <a
                                        onClick={handleshow}
                                        variant="success"
                                        type="button"
                                        className="btn my-1 me-2 btn-success tx-teko"
                                    >
                                        {" "}
                                        Add
                                    </a>
                                </div>
                                <div className="ag-theme-alpine ag-style">
                                    <AgGridReact
                                        columnDefs={localStorage.getItem("Role") === "1" ? columnDefs : columnWDefs}
                                        rowData={filterProduct}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>

                            <Modal show={show}>
                                <Modal.Header>
                                    {Catid === 0 ? <h4>Add Hostel</h4> : <h4>Hostel Detail</h4>}
                                </Modal.Header>
                                <Modal.Body>
                                    <Row className="row-sm mx-0">
                                        {localStorage.getItem("Role") === "1" && (
                                            <Col lg={12} md={12}>
                                                <div className="form-label">
                                                    <label className="mb-2">
                                                        Select Academy
                                                        <span className="text-danger"> *</span>

                                                    </label>
                                                </div>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Academy"
                                                    value={acaid}
                                                    options={alist}
                                                    onChange={handleAcademy}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />

                                            </Col>
                                        )}

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Hostel <span className="text-danger"> *</span>
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter Your Hostel"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </div>
                                        </Col>

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Type <span className="text-danger"> *</span>
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <select value={htype} onChange={(e) => setHType(e.target.value)}>
                                                    <option value="">Select Type</option>
                                                    <option value="Boys">Boys</option>
                                                    <option value="Girls">Girls</option>
                                                </select>
                                            </div>
                                        </Col>

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Address
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter Your Address"
                                                    value={addr}
                                                    onChange={(e) => setAddr(e.target.value)}
                                                />
                                            </div>
                                        </Col>

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Total Members
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter Your Total Members"
                                                    value={tmem}
                                                    onChange={(e) => setTMem(e.target.value)}
                                                />
                                            </div>
                                        </Col>

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Warden
                                                </label>
                                            </div>
                                            <div>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Warden"
                                                    value={driverid}
                                                    options={dlist}
                                                    onChange={handleDriver}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />

                                            </div>
                                        </Col>
                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Description
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <textarea
                                                    rows="3"
                                                    placeholder="Enter Your Description"
                                                    value={desc}
                                                    onChange={(e) => setDesc(e.target.value)}
                                                />
                                            </div>
                                        </Col>
                                        {errorMessage !== "" && (
                                            <span className="text-danger">{errorMessage}</span>
                                        )}
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    {Catid === 0 ? (
                                        <a
                                            onClick={Submitage}
                                            className="btn btn-next btn-success"
                                            style={{ float: "right" }}
                                        >
                                            Submit
                                        </a>
                                    ) : (
                                        <a
                                            onClick={Submitage}
                                            className="btn btn-next btn-success"
                                            style={{ float: "right" }}
                                        >
                                            Update
                                        </a>
                                    )}
                                    <a
                                        className="btn btn-next btn-secondary"
                                        style={{ float: "right" }}
                                        onClick={handleclose}
                                    >
                                        Close
                                    </a>
                                </Modal.Footer>
                            </Modal>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
};
